module.exports = __webpack_public_path__ + "assets/f63dad0e816ff9e25e92d3f2548c3cc1.png";